// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IYTQ36JjP8LFfuARdfaf{width:80%;height:100px;display:flex;flex-direction:column;gap:2em}.IYTQ36JjP8LFfuARdfaf .Z0gi1owimno4PF0wAN30{display:flex;flex-direction:row;align-items:center;gap:3em}.IYTQ36JjP8LFfuARdfaf .Z0gi1owimno4PF0wAN30>div:first-child{flex:1 1;text-align:center}.IYTQ36JjP8LFfuARdfaf .Z0gi1owimno4PF0wAN30>div:last-child{flex:4 1}.IYTQ36JjP8LFfuARdfaf .paQKJMXVibYRk89NdubX{display:flex;justify-content:center}.IYTQ36JjP8LFfuARdfaf .paQKJMXVibYRk89NdubX.xH1ixtOKwynhK9v8H7Ee{justify-content:flex-start}.IYTQ36JjP8LFfuARdfaf .paQKJMXVibYRk89NdubX.HdsRF6VtGLl6ELUAR3l9{justify-content:flex-end}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `IYTQ36JjP8LFfuARdfaf`,
	"sliderRow": `Z0gi1owimno4PF0wAN30`,
	"buttonRow": `paQKJMXVibYRk89NdubX`,
	"alignLeft": `xH1ixtOKwynhK9v8H7Ee`,
	"alignRight": `HdsRF6VtGLl6ELUAR3l9`
};
export default ___CSS_LOADER_EXPORT___;
